import React, { useState } from 'react';

import { Box, Button, Text } from '@betterment/samba-react';
import copy from 'copy-to-clipboard';

import { useReferralKey } from './ReferAFriendProvider';

import { trackClick } from '../../features/track';

interface CopyableReferralKeyProps {
  trackingModule: string;
}

const CopyableReferralKey: React.FC<React.PropsWithChildren<CopyableReferralKeyProps>> = ({ trackingModule }) => {
  const { referralKey } = useReferralKey();

  const getReferralLink = (personalReferralKey: string | null): string => {
    const referralParams = personalReferralKey ? `?referral_key=${personalReferralKey}` : '';
    return `betterment.com/friend-referral-offer${referralParams}`;
  };

  const [isCopied, setIsCopied] = useState(false);

  const copyReferralLink = () => {
    copy(getReferralLink(referralKey));
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };

  return (
    <Box css={{ display: 'flex', alignItems: 'center', justifyContent: 'center', pt: 'space.200' }}>
      {isCopied ? (
        <Text as="p" color="text.success" css={{ marginBottom: 'space.200', _last: { marginBottom: 'space.0' } }}>
          Copied referral link
        </Text>
      ) : (
        <Button
          variant="textPrimary"
          onClick={() => {
            trackClick({ module: trackingModule, name: 'CopyReferralKey' });
            copyReferralLink();
          }}
          aria-label="Copy referral link to clipboard"
          title="Copy referral link to clipboard"
          data-testid="copy-link"
          css={{ textAlign: 'center' }}
        >
          Copy your personalized link
        </Button>
      )}
    </Box>
  );
};

export default CopyableReferralKey;
